const HomeBackground = () => {
  return (
    // translateZ(0)+will-change 把固定背景提升为独立合成层,滚动时前景卡片只做 GPU 合成,
    // 不再触发整屏背景重绘(fixed 图片+多层渐变背景在滚动时逐帧重绘是卡顿主因)。
    <div className="fixed inset-0 -z-10 h-full w-full overflow-hidden bg-[#030712]" style={{ transform: 'translateZ(0)', willChange: 'transform' }}>
      <div className="absolute inset-0 bg-[url('/cover.jpeg')] bg-cover bg-center" />
      <div className="bg-black/35 absolute inset-0" />
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(255,153,102,0.18),transparent_50%),radial-gradient(circle_at_80%_25%,rgba(91,147,255,0.18),transparent_45%),radial-gradient(circle_at_50%_80%,rgba(126,255,173,0.12),transparent_45%)] opacity-80" />
        <div className="absolute inset-0 bg-[linear-gradient(0deg,rgba(255,255,255,0.04),transparent_60%),linear-gradient(120deg,rgba(255,255,255,0.03),transparent_40%)] opacity-60" />
      </div>
    </div>
  )
}

export default HomeBackground
